import {APPLICATION_REQUEST, APPLICATION_SUCCESS, APPLICATION_FAILURE} from '../actions';
import {APPLICATION_PATCH_REQUEST, APPLICATION_PATCH_SUCCESS, APPLICATION_PATCH_FAILURE} from '../actions';
import {DOCUMENT_UPLOAD_REQUEST, DOCUMENT_UPLOAD_SUCCESS, DOCUMENT_UPLOAD_FAILURE} from '../actions';
import {DOCUMENT_DELETE_REQUEST, DOCUMENT_DELETE_SUCCESS, DOCUMENT_DELETE_FAILURE} from '../actions';

export const APPLICATION_INITIAL_STATE = {
    id: null,
    isFetching: false,
    error: null,
    documents: []
};

const applicationReducers = {
    [APPLICATION_REQUEST]: (state, {id}) => {
        return {...state, id, isFetching: true, error: null};
    },
    [APPLICATION_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null};
    },
    [APPLICATION_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [APPLICATION_PATCH_REQUEST]: (state, action) => {
        return {...state, isFetching: true, error: null};
    },
    [APPLICATION_PATCH_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [APPLICATION_PATCH_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error}
    },
    [DOCUMENT_UPLOAD_REQUEST]: (state, action) => {
        return {...state, isFetching: true, error: null};
    },
    [DOCUMENT_UPLOAD_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [DOCUMENT_UPLOAD_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error}
    },
    [DOCUMENT_DELETE_REQUEST]: (state, action) => {
        return {...state, isFetching: true, error: null};
    },
    [DOCUMENT_DELETE_SUCCESS]: (state, {docId}) => {
        const documents = [...state.documents].filter(doc => doc.id !== docId);
        return {...state, documents, isFetching: false, error: null}
    },
    [DOCUMENT_DELETE_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error}
    }
};

export default function application(state = APPLICATION_INITIAL_STATE, action) {
    let reducer = applicationReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/application.js